import { render, staticRenderFns } from "./EmployeeResources.vue?vue&type=template&id=1fd76442&"
import script from "./EmployeeResources.vue?vue&type=script&lang=js&"
export * from "./EmployeeResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports